var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "currency-wrapper" }, [
    _c("div", { staticClass: "small-title bold" }, [
      _vm._v(_vm._s(_vm.$t("setting.currency")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "setting common-list-wrapper __pointer" }, [
      _c(
        "span",
        {
          staticClass: "list-title",
          class: {
            down: !_vm.isShow,
            up: _vm.isShow
          },
          on: { click: _vm.toggleList }
        },
        [_vm._v(_vm._s(_vm.currency))]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShow,
              expression: "isShow"
            }
          ],
          staticClass: "list"
        },
        _vm._l(_vm.list, function(item, index) {
          return _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: item !== _vm.currency,
                  expression: "item !== currency"
                }
              ],
              key: index,
              on: {
                click: function($event) {
                  return _vm.setVal(item)
                }
              }
            },
            [_vm._v(_vm._s(item))]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }